<template>
  <svg
    class="block"
    fill="none"
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      v-if="!bare"
      width="96"
      height="96"
      rx="18.75"
      fill="#0052ff"
    />
    <path
      :class="markClass"
      fill="#ffffff"
      d="M54.926 79.164C54.246 79.164 53.52 79.078 52.84 78.91 51.477 78.57 50.199 77.844 49.176 76.82 48.836 76.48 48.535 76.055 48.367 75.586 42.953 59.863 37.16 54.066 20.242 47.547 19.816 47.379 19.434 47.121 19.09 46.781 18.109 45.758 17.387 44.48 17.004 43.117 16.664 41.754 16.664 40.262 17.004 38.898 17.387 37.535 18.109 36.254 19.133 35.234 20.156 34.211 21.391 33.484 22.797 33.145L62.98 23.09C64.344 22.746 65.793 22.789 67.156 23.133 68.52 23.516 69.758 24.238 70.734 25.219 71.758 26.242 72.484 27.477 72.824 28.84 73.207 30.203 73.207 31.652 72.867 33.016L62.852 73.027C62.469 74.477 61.746 75.715 60.723 76.734 59.699 77.758 58.422 78.484 57.059 78.867 56.375 79.078 55.652 79.164 54.926 79.164ZM54.117 72.559C54.117 72.559 54.332 72.645 54.457 72.688 54.758 72.773 55.098 72.773 55.395 72.688 55.695 72.602 55.992 72.434 56.207 72.219 56.418 72.008 56.59 71.707 56.676 71.41L66.688 31.441C66.773 31.141 66.773 30.844 66.688 30.547 66.602 30.246 66.434 29.949 66.219 29.734 66.008 29.523 65.707 29.352 65.41 29.266 65.113 29.184 64.813 29.184 64.516 29.266L24.504 39.324C24.246 39.41 23.949 39.535 23.734 39.793 23.523 40.004 23.352 40.305 23.266 40.602 23.184 40.898 23.184 41.242 23.266 41.539 23.266 41.668 23.352 41.797 23.438 41.922 41.164 48.91 48.238 55.984 54.16 72.602ZM54.117 72.559"
    />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  bare: {
    type: Boolean,
    default: false,
  },
  clipId: {
    type: String,
    default: 'frappe-brand-clip',
  },
  markColor: {
    type: String,
    default: 'adaptive',
    validator: value => ['adaptive', 'light'].includes(value),
  },
})

const markClass = computed(() => 'fill-white')
</script>
